/* eslint-disable no-console */
import { useRouter } from 'next/router'

import { useEventBufferFlush } from '~/behavior-tracking/hooks/useEventBufferFlush'
import usePageVisitTracker from '~/behavior-tracking/hooks/usePageVisitTracker'
import usePageVisibilityTracker from '~/behavior-tracking/hooks/usePageVisibilityTracker'
import usePageLeaveTracker from '~/behavior-tracking/hooks/usePageLeaveTracker'
import usePageUnloadTracker from '~/behavior-tracking/hooks/usePageUnloadTracker'
import useUserPulseTracker from '~/behavior-tracking/hooks/useUserPulseTracker'
import useStoredEventCleanUp from '~/behavior-tracking/hooks/useStoredEventCleanUp'
import { useAppSelector } from '~/redux/hooks'
import { selectUserId } from '~/auth/slices/auth.slice'
import { useVideoWatchTracker } from '~/behavior-tracking/hooks/useVideoWatchTracker'

export function useViewTracking(): void {
  const router = useRouter()
  const userId = useAppSelector(selectUserId)

  usePageVisitTracker(router, userId)
  usePageVisibilityTracker(router, userId)
  usePageLeaveTracker(router, userId)
  usePageUnloadTracker(router, userId)
  useUserPulseTracker(router, userId)
  useVideoWatchTracker(router, userId)

  useEventBufferFlush(userId)
  useStoredEventCleanUp(userId)
}
